import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { BackArrowIcon } from "../../Icons";
import Create from "../../pages/TeamManagement/create";
import Breadcrumbs from "../Breadcrumb/Breadcrumbs";
import GroupInfoPanel from "../InfoPanels/GroupInfoPanel";
import SectionNavigation from "../SectionNavigation/sectionnavigation";
import {
  APPLICATION_TAB_TYPE,
  AR_CONTENT_TAB,
  GROUP_TAB_TYPE,
  RESOURCE_APPLICATION_TAB,
  RESOURCE_ENVIRONMENT_TAB,
  RESOURCE_MODULE_TAB,
  RESOURCE_SKILL_SCHOOL_TAB,
  RESOURCE_SKILL_STREAM_TAB,
  statusOptions,
  USER_TAB_TYPE,
} from "../../constant/constants";
import {
  GROUP_CREATE_PERMISSION,
  GROUP_VIEW_PERMISSION,
  RESOURCE_VIEW_PERMISSION,
  USER_VIEW_PERMISSION,
} from "../../constant/permission";
import { checkPermissionExist, visibleAssignSectionList } from "../../utils/general";
import AnimatedCreationBtn from "../ForMobile/AnimatedCreationBtn";
import SearchbarMobile from "../ForMobile/SearchbarMobile";
import { useDispatch, useSelector } from "react-redux";
import apiClient from "../../apiClient";
import { GROUP_DETAILS } from "../../apiClient/apiEndpoints";
import { resetTotalCount, saveTotalCount } from "../../store/slice/filterOptions";

const { BackButton } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const permissionTabMap = {
  [GROUP_VIEW_PERMISSION]: GROUP_TAB_TYPE,
  [USER_VIEW_PERMISSION]: USER_TAB_TYPE,
  [RESOURCE_VIEW_PERMISSION]: APPLICATION_TAB_TYPE,
};

let tabPermissions = [GROUP_VIEW_PERMISSION, USER_VIEW_PERMISSION, RESOURCE_VIEW_PERMISSION];

const getInitialActiveTab = () => {
  for (const permission of tabPermissions) {
    if (checkPermissionExist(permission)) {
      return permissionTabMap[permission];
    }
  }
  return null;
};

const TeamManagement = ({ isMobileView }) => {
  const dispatch = useDispatch();
  const configData = useUnoSelector((state) => state.config);
  const configSlice = useSelector((state) => state.configSlice);
  const [showFilter, setShowFilter] = useState(false);
  const [defaultTab, setDefaultTab] = useState("");
  const UNO_URL = configData?.config?.UNO_URL;
  const params = useParams();
  const UUID = params?.uuid;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(getInitialActiveTab());
  const [refreshTab, setRefreshTab] = useState(true);
  const [currentTab, setCurrentTab] = useState(GROUP_TAB_TYPE);
  const [details, setDetails] = useState({
    avatar: null,
    [GROUP_TAB_TYPE]: null,
    handDown: false,
    inherit: false,
    name: null,
    type: { color: null, name: null },
    uuid: null,
  });
  const [filterOptions, setFilterOptions] = useState({
    [GROUP_TAB_TYPE]: [],
    [USER_TAB_TYPE]: [],
    [APPLICATION_TAB_TYPE]: [],
  });
  const [applicationSelectedCheckboxes, setApplicationSelectedCheckboxes] = useState({
    [RESOURCE_APPLICATION_TAB]: [],
    [RESOURCE_MODULE_TAB]: [],
    [RESOURCE_ENVIRONMENT_TAB]: [],
    [RESOURCE_SKILL_STREAM_TAB]: [],
    [RESOURCE_SKILL_SCHOOL_TAB]: [],
    [AR_CONTENT_TAB]: [],
  });
  const [groupSelectedCheckboxes, setGroupSelectedCheckboxes] = useState([]);
  const [userSelectedCheckboxes, setUserSelectedCheckboxes] = useState([]);

  const [isScrolled, setIsScrolled] = useState(false);
  const backClick = () => navigate(-1);

  useEffect(() => {
    let _visibleApplicationTabs = visibleAssignSectionList();
    setDefaultTab(_visibleApplicationTabs.length > 0 ? _visibleApplicationTabs[0].id_link : "")

    return () => {
      dispatch(resetTotalCount())
    }

  }, [])

  const handleRefreshTab = () => setRefreshTab((pre) => !pre);

  const getGroupDetails = async () => {
    try {
      let data = await apiClient.get(`${UNO_URL}${GROUP_DETAILS}/${UUID}`);
      setDetails(data);
      dispatch(saveTotalCount({ data: { [GROUP_TAB_TYPE]: data?._count?.children } }))
      dispatch(saveTotalCount({ data: { [USER_TAB_TYPE]: data?._count?.users } }))
      dispatch(saveTotalCount({ data: { [RESOURCE_APPLICATION_TAB]: data?._count?.applications } }))
    } catch (error) {
      console.log(error);
    }
  };

  // const resetToDefault = () => {
  //   window.scrollTo({
  //     top: 0,
  //     left: 0,
  //     behavior: "instant",
  //   });
  // };

  useEffect(() => {
    if (UUID) getGroupDetails();
    //   resetToDefault();
  }, [UUID]);

  const handleSelectItem = (newItem) => {
    if (activeTab === APPLICATION_TAB_TYPE) {
      setApplicationSelectedCheckboxes((prev) => {
        const currentArray = prev[defaultTab] || [];
        const exists = currentArray.some((selectedItem) => selectedItem.value === newItem.value);

        const updatedArray = exists
          ? currentArray.filter((selectedItem) => selectedItem.value !== newItem.value) // Remove
          : [...currentArray, newItem];

        return {
          ...prev,
          [defaultTab]: updatedArray,
        };
      });
      return;
    }

    const setters = {
      [GROUP_TAB_TYPE]: setGroupSelectedCheckboxes,
      [USER_TAB_TYPE]: setUserSelectedCheckboxes,
    };

    const setSelected = setters[activeTab];
    if (!setSelected) return;

    setSelected((prev) => {
      const exists = prev.some((item) => item.value === newItem.value);
      return exists ? prev.filter((item) => item.value !== newItem.value) : [...prev, newItem];
    });
  };

  const handleResetCheckBox = () => {
    if (activeTab === APPLICATION_TAB_TYPE) {
      setApplicationSelectedCheckboxes((prev) => {
        return {
          ...prev,
          [defaultTab]: [],
        };
      });
      return;
    }

    const setters = {
      [GROUP_TAB_TYPE]: setGroupSelectedCheckboxes,
      [USER_TAB_TYPE]: setUserSelectedCheckboxes,
    };
    setters?.[activeTab]([]);
  };

  useEffect(() => {
    const mapRoles = (roles) => roles.map(({ id, name }) => ({ value: id, name, key: name, type: "role" }));

    setFilterOptions({
      [GROUP_TAB_TYPE]: [
        {
          name: "Status",
          tags: statusOptions,
        },
        {
          name: "Group types",
          tags: mapRoles(configSlice.groupTypes),
        },
      ],
      [USER_TAB_TYPE]: [
        {
          name: "Status",
          tags: statusOptions,
        },
        {
          name: "Roles",
          tags: mapRoles(configSlice.roles),
        },
      ],
      [APPLICATION_TAB_TYPE]: [],
    });
  }, [UUID, configSlice]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  let getSelectedItem = {
    [GROUP_TAB_TYPE]: groupSelectedCheckboxes,
    [USER_TAB_TYPE]: userSelectedCheckboxes,
    [APPLICATION_TAB_TYPE]: applicationSelectedCheckboxes,
  };

  let selectedItems =
    activeTab === APPLICATION_TAB_TYPE ? getSelectedItem[activeTab][defaultTab] : getSelectedItem[activeTab];

  return (
    <>
      <div className="team-management">
        {!isMobileView ?
          <div className="page-title with-fuctions ">
            <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
            <div className="title-n-breads-wrapper">
              <div className="title-n-breads">
                <p>Team Management</p>
                <span className="separator"> {""} </span>
                <Breadcrumbs UNO_URL={UNO_URL} UUID={UUID} activeCrumb={UUID} />
              </div>
            </div>
            <Create currentTab={currentTab} handleRefreshTab={handleRefreshTab} tabType={GROUP_TAB_TYPE} details={details} />
          </div>
          :
          <>
            <div className={`mob-header ${isScrolled ? "scroll-pause" : "normal"}`} >
              <div className={`page-title mob with-backBtn`}>
                <div className="backButtonWrapper">
                  <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                </div>
                <div className="mobSearchParent">
                  <SearchbarMobile
                    showFilterBtn={true}
                    activeTab={activeTab === APPLICATION_TAB_TYPE ? defaultTab : activeTab}
                    selectedCheckboxes={selectedItems}
                    handleResetCheckBox={handleResetCheckBox}
                    handleSelectApplication={handleSelectItem}
                  />
                </div>
              </div>
            </div>
          </>
        }

        <div className={checkPermissionExist(GROUP_CREATE_PERMISSION) ? "team-functions tab-content-hide" : "team-functions tab-content-hide no-edit"} >
          <div className="team-info ">
            <GroupInfoPanel
              params={params}
              handleRefreshTab={handleRefreshTab}
              isMobileView={isMobileView}
              details={details}
              getGroupDetails={getGroupDetails}
            />
          </div>

          <div className={currentTab === APPLICATION_TAB_TYPE ? `team-stats for-assigned` : "team-stats"}>
            <SectionNavigation
              UUID={UUID}
              showfilter={showFilter}
              setShowFilter={setShowFilter}
              setCurrentTab={setCurrentTab}
              refreshTab={refreshTab}
              UNO_URL={UNO_URL}
              isMobileView={isMobileView}
              filterOptions={filterOptions}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              defaultTab={defaultTab}
              setDefaultTab={setDefaultTab}
              applicationSelectedCheckboxes={applicationSelectedCheckboxes}
              setApplicationSelectedCheckboxes={setApplicationSelectedCheckboxes}
              groupSelectedCheckboxes={groupSelectedCheckboxes}
              setGroupSelectedCheckboxes={setGroupSelectedCheckboxes}
              userSelectedCheckboxes={userSelectedCheckboxes}
              setUserSelectedCheckboxes={setUserSelectedCheckboxes}
            />
          </div>
        </div>

        {isMobileView && <AnimatedCreationBtn currentTab={currentTab} handleRefreshTab={handleRefreshTab} />}
      </div>
    </>
  );
};

export default TeamManagement;
